// Define the application status types
export type FactoringStatusType =
  | "APPLICATION_RECEIVED" // 申込受付
  | "UNDER_REVIEW" // 審査中
  | "WAITING_FOR_DOCUMENTS" // 書類待ち
  | "APPROVED" // 可決
  | "REJECTED" // 否決
  | "NOTIFICATION"; // お知らせ

// Map from English to Japanese for backward compatibility
export const statusToJapanese: Record<FactoringStatusType, string> = {
  APPLICATION_RECEIVED: "申込受付",
  UNDER_REVIEW: "審査中",
  WAITING_FOR_DOCUMENTS: "書類待ち",
  APPROVED: "可決",
  REJECTED: "否決",
  NOTIFICATION: "お知らせ",
};

// Define color mapping for each status
export const statusColorMap: Record<FactoringStatusType, string> = {
  APPLICATION_RECEIVED: "#1976d2", // Blue
  UNDER_REVIEW: "#ff9800", // Orange
  WAITING_FOR_DOCUMENTS: "#9c27b0", // Purple
  APPROVED: "#4caf50", // Green
  REJECTED: "#f44336", // Red
  NOTIFICATION: "#607d8b", // Blue Grey
};

export const getStatusColor = (status: FactoringStatusType): string => (statusColorMap[status]);
